"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const silo_1 = require("services/silo");
const silo_pos_types_1 = require("./silo-pos.types");
const getLandingPageSilo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_1._getLandingPageSilo)(payload);
    if (response.isError) {
        dispatch({
            type: silo_pos_types_1.siloPosTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            },
        });
    }
    else {
        const payload = {
            DeviceData: response.data.DeviceData,
            countDataTransaction: response.countDataTransaction,
            TransactionDataSilo: response.data.TransactionDataSilo,
            ConfigurationCheckPointData: response.data.ConfigurationCheckPointData
        };
        dispatch({ type: silo_pos_types_1.siloPosTypes.GET_LANDING_PAGE_DATA_SILO, payload });
    }
});
const toggleError = payload => dispatch => {
    dispatch({ type: silo_pos_types_1.siloPosTypes.SET_ERROR, payload });
};
const toggleLoading = payload => dispatch => {
    dispatch({ type: silo_pos_types_1.siloPosTypes.SET_LOADING, payload });
};
const resetSelectedPos = payload => dispatch => {
    dispatch({ type: silo_pos_types_1.siloPosTypes.RESET_SELECTED_POS, payload });
};
const setSelectedChild = payload => dispatch => {
    dispatch({ type: silo_pos_types_1.siloPosTypes.SET_SELECTED_CHECKPOINT, payload: payload });
};
exports.default = {
    toggleError,
    toggleLoading,
    resetSelectedPos,
    setSelectedChild,
    getLandingPageSilo
};
